import { type OrganizationSocialResponse } from '@on3/api';
import { On3IconPopOut } from '@on3/icons';
import { SocialIcon } from '@on3/ui-lib/components/SocialIcon';
import { useMemo } from 'react';

import { INACTIVE_COLOR } from '../HighSchoolPage';
import styles from './SocialHandles.module.scss';

export const SocialHandles = ({
  socials,
  primaryColor,
  website,
  selectedSport,
}: {
  socials?: OrganizationSocialResponse;
  primaryColor?: string | null;
  website?: string | null;
  selectedSport?: string | null;
}) => {
  const textColorStyle = useMemo(
    () => ({ color: primaryColor ?? INACTIVE_COLOR }),
    [primaryColor],
  );

  const twitterHandle =
    selectedSport === 'football'
      ? socials?.footballTwitter
      : socials?.basketballTwitter;
  const instagramHandle =
    selectedSport === 'football'
      ? socials?.footballInstagram
      : socials?.basketballInstagram;

  return (
    <div className={styles.handles}>
      <ul>
        {website && (
          <li>
            <a href={website} rel="noopener noreferrer" target="_blank">
              <On3IconPopOut
                className={styles.logo}
                fill={primaryColor ?? ''}
              />
              <span style={textColorStyle}>Official Website</span>
            </a>
          </li>
        )}
        {socials?.athleticsTwitter && (
          <li>
            <a
              href={`https://twitter.com/${socials?.athleticsTwitter}/`}
              rel="noopener noreferrer"
              target="_blank"
            >
              <SocialIcon
                className={styles.logo}
                fill={primaryColor ?? ''}
                type="x"
              />
              <span
                style={textColorStyle}
              >{`@${socials?.athleticsTwitter}`}</span>
            </a>
          </li>
        )}
        {twitterHandle && (
          <li>
            <a
              href={`https://x.com/${twitterHandle}/`}
              rel="noopener noreferrer"
              target="_blank"
            >
              <SocialIcon
                className={styles.logo}
                fill={primaryColor ?? ''}
                type="x"
              />
              <span style={textColorStyle}>{`@${twitterHandle}`}</span>
            </a>
          </li>
        )}
        {socials?.athleticsInstagram && (
          <li>
            <a
              href={`https://instagram.com/${socials?.athleticsInstagram}/`}
              rel="noopener noreferrer"
              target="_blank"
            >
              <SocialIcon
                className={styles.logo}
                fill={primaryColor ?? ''}
                type="instagram"
              />
              <span style={textColorStyle}>
                {`@${socials?.athleticsInstagram}`}
              </span>
            </a>
          </li>
        )}
        {instagramHandle && (
          <li>
            <a
              href={`https://instagram.com/${instagramHandle}/`}
              rel="noopener noreferrer"
              target="_blank"
            >
              <SocialIcon
                className={styles.logo}
                fill={primaryColor ?? ''}
                type="instagram"
              />
              <span style={textColorStyle}>{`@${instagramHandle}`}</span>
            </a>
          </li>
        )}
      </ul>
    </div>
  );
};
